export default [{
  path: '/kpis-aderencias-bdgd',
  component: () => import('@/views/Index'),
  children: [
    {
      name: 'KPIs Aderências BDGD Histórico',
      path: 'historico',
      component: () => import('@/views/kpisAderenciasBdgd/Historico.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          { name: 'Power Ups', path: '/powerups' },
          { name: 'KPIs Aderências BDGD' }
        ]
      }
    },
    {
      name: 'KPIs Aderências BDGD Adicionar',
      path: 'add',
      component: () => import('@/views/kpisAderenciasBdgd/Add.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          { name: 'Power Ups', path: '/powerups' },
          { name: 'KPIs Aderências BDGD', path: '/kpis-aderencias-bdgd/historico' },
          { name: 'Adicionar' }
        ]
      }
    },
    {
      name: 'KPIs Aderências BDGD Visualizar Gráficos',
      path: 'graficos/:id',
      component: () => import('@/views/kpisAderenciasBdgd/Visualizar.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          { name: 'Power Ups', path: '/powerups' },
          { name: 'KPIs Aderências BDGD', path: '/kpis-aderencias-bdgd/historico' },
          { name: 'Visualizar Gráficos' }
        ]
      }
    }
  ]
}]